type Disconnectable = { disconnect: () => unknown };

let current: Disconnectable | null = null;

export const currentLiveSocket = <T extends Disconnectable>(): T | null => current as T | null;

export const storeLiveSocket = <T extends Disconnectable>(socket: T): T => {
  current = socket;
  return socket;
};

export const resetLiveSocket = (): void => {
  current?.disconnect();
  current = null;
};
